import React from "react";

export default function ForgotPasswordRequest({
  username,
  setUsername,
  Api,
  onStateChange
}) {
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await Api.forgotPassword(username);
      alert("A verification code has been sent to your email");
      onStateChange("forgot_password_confirm");
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        width: "300px",
        padding: "40px",
        backgroundColor: "#111d30",
        borderRadius: "12px",
        border: "1px solid #22416b",
        boxShadow: "0px 16px 36px rgba(10, 22, 42, 0.45)",
      }}
    >
      <h2 style={{ textAlign: "center", marginBottom: "20px", color: "#e7edf7" }}>Reset Password</h2>

      <input
        type="text"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        placeholder="Username"
        style={{
          width: "100%",
          padding: "10px",
          marginBottom: "20px",
          backgroundColor: "#0f1e33",
          color: "#e7edf7",
          border: "1px solid #22416b",
          borderRadius: "8px",
        }}
      />

      <button
        type="submit"
        style={{
          width: "100%",
          padding: "10px",
          background: "linear-gradient(135deg, #1f6feb 0%, #0f355e 100%)",
          color: "#e7edf7",
          border: "1px solid #2c4f83",
          borderRadius: "10px",
          cursor: "pointer",
          boxShadow: "0 10px 24px rgba(15, 53, 94, 0.45)",
        }}
      >
        Send Reset Code
      </button>

      <button
        type="button"
        onClick={() => onStateChange("login")}
        style={{
          marginTop: "10px",
          width: "100%",
          padding: "10px",
          backgroundColor: "transparent",
          border: "none",
          color: "#5dd0ff",
          cursor: "pointer",
          textDecoration: "underline",
        }}
      >
        Back to Login
      </button>
    </form>
  );
}
